import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Chip,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
  ArrowOutward,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import IosShareIcon from "@mui/icons-material/IosShare";
import { ExportLogsModal } from "./features/export-logs-modal";

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

export const LogsGrid = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});
  console.log("what is users", users);

  const [data, setData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState({
    caseId: "",
    motherID: "",
    action: "",
    from: null,
    to: null,
  });
  const [openExportModal, setOpenExportModal] = useState(false);

  const getReports = () => {
    axios
      .get(
        `${API_HOST_CRM}/cases/logs?user=just&limit=${rowsPerPage}${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""
        }${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}${filter.caseId ? `&caseId=${filter.caseId}` : ""
        }${filter.motherID ? `&motherID=${filter.motherID}` : ""}${filter.action ? `&action=${filter.action}` : ""
        }${filter.allocatedToUser
          ? `&allocatedToUser=${filter.allocatedToUser}`
          : ""
        }${filter.actionBy ? `&actionBy=${filter.actionBy}` : ""}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.data);
          setCount(0);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getReports();
  }, []);
  useEffect(() => {
    getReports();
  }, [filter, rowsPerPage]);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <ToolBar
          name={"Cases Logs"}
          buttons={[
            {
              name: `Export Logs`,
              icon: () => <ArrowOutward sx={{ fontSize: "1.2em" }} />,
              onClick: () => setOpenExportModal(true),
            },
          ]}
          filters={[
            {
              field: {
                name: "from",
                type: "date",
                label: "Created From",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
            {
              field: {
                name: "to",
                type: "date",
                label: "Created To",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
          ]}
        />
        <Box sx={{ mt: 2 }}>
          <Grid
            data={data}
            columns={[
              {
                id: "motherID",
                // label: "Mother ID",
                minWidth: 40,
                field: {
                  name: "motherID",
                  type: "text",
                  label: "Mother ID",
                  // option: { key: "actionBy", value: "_id", label: "name" },
                  // multiple: true,
                },
                editable: true,
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },
              {
                id: "caseId",
                label: "CaseId",
                minWidth: 70,
                field: {
                  name: "caseId",
                  type: "text",
                  label: "CaseId",
                  // option: { key: "actionBy", value: "_id", label: "name" },
                  // multiple: true,
                },
                editable: true,
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },
              {
                id: "action",
                format: (data, row) => {
                  return data;
                },
                isSelect: true,
                // label: "Action By",

                field: {
                  name: "action",
                  type: "select",
                  label: "Action",
                  option: { key: "action", value: "_id", label: "name" },
                  // multiple: true,
                },
                // editable: true,
                data: {
                  action: [
                    // {
                    //   _id: "Any",
                    //   name: "Any",
                    // },
                    ...[
                      "new-case-inbound",
                      "new-case-mother",
                      "status-change",
                      "status-edit",
                      "new-case-followup",
                      "transferCase",
                      "transferCase-lang",
                      "unassign-lang",
                      "case-assign-selected",
                      "unassign-cases",
                      "case-assign-auto",
                      "auto-assign-cases",
                      "status-update-saga-failed"
                    ].map((action) => ({ _id: action, name: action })),
                    // ...(users || []).filter((u) => {
                    //   return u.roles.includes(process.env.REACT_APP_TELECALLER);
                    // }),
                  ],
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },

              // {
              //   id: "action",
              //   label: "Action",
              //   minWidth: 70,
              //   field: {
              //     name: "action",
              //     type: "text",
              //     label: "Action",
              //     // option: { key: "actionBy", value: "_id", label: "name" },
              //     // multiple: true,
              //   },
              //   editable: true,
              //   onChange: (name, value) => {
              //     filter[name] = value;
              //     setFilter({ ...filter });
              //   },
              //   state: filter,
              // },
              {
                id: "callStatus",
                label: "Call Status",
                minWidth: 70,
                format: (data, row) => {
                  return data
                    ? data
                    : row?.obj
                      ? JSON.parse(row.obj)?.status
                      : "";
                },
              },
              { id: "state", label: "State", minWidth: 70 },

              //   {
              //     id: "actionBy",
              //     label: "actionBy",
              //     minWidth: 70,
              //     format: (data, row) => {
              //       return map?.users?.[data] ? map?.users?.[data].name : "";
              //     },
              //   },
              {
                id: "actionBy",
                format: (data, row) => {
                  return map?.users?.[data]?.name || "";
                },
                isSelect: true,
                // label: "Action By",

                field: {
                  name: "actionBy",
                  type: "select",
                  label: "Action By",
                  option: { key: "actionBy", value: "_id", label: "name" },
                  multiple: true,
                },
                // editable: true,
                data: {
                  actionBy: [
                    // {
                    //   _id: "Any",
                    //   name: "Any",
                    // },
                    ...(users || []),
                    // ...(users || []).filter((u) => {
                    //   return u.roles.includes(process.env.REACT_APP_TELECALLER);
                    // }),
                  ],
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },

              //   {
              //     id: "allocatedToUser",
              //     label: "Allocated To",
              //     minWidth: 70,
              //     format: (data, row) => {
              //       return data ? data.name : "";
              //     },
              //   },
              {
                id: "allocatedToUser",
                format: (data, row) => {
                  return data ? data.name : "";
                },
                isSelect: true,
                // label: "AllocatedTo",

                field: {
                  name: "allocatedToUser",
                  type: "select",
                  label: "Allocated To",
                  option: {
                    key: "allocatedToUser",
                    value: "_id",
                    label: "name",
                  },
                  multiple: true,
                },
                // editable: true,
                data: {
                  allocatedToUser: [
                    // {
                    //   _id: "Any",
                    //   name: "Any",
                    // },
                    ...(users || []).filter((u) => {
                      return u.roles.includes(process.env.REACT_APP_TELECALLER);
                    }),
                  ],
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },

              {
                id: "actionDate",
                label: "Action Time",
                minWidth: 70,
                format: (data, row) => {
                  return data ? dayjs(data).format("DD/MM/YYYY HH:mm:ss") : "";
                },
              },
              {
                id: "callDate",
                label: "Call Date",
                minWidth: 70,
                format: (data, row) => {
                  return data ? dayjs(data).format("DD/MM/YYYY HH:mm:ss") : "";
                },
              },
            ]}
            pagination={{
              rowsPerPageOptions: [10, 25, 50, 100, 200, 500],
              page,
              rowsPerPage,
              onPageChange: (event, newPage) => {
                setPage(newPage);
              },
              onRowsPerPageChange: (event) => {
                setRowsPerPage(+event.target.value);
                setPage(0);
              },
              count,
            }}
          ></Grid>
        </Box>
      </Box>
      <ExportLogsModal
        open={openExportModal}
        onClose={() => setOpenExportModal(false)}
      />
    </>
  );
};
